import { t } from "i18next";
import UserWalkthrough from "./UserWalkthrough";
import UserWalkthroughSteps from "../../types/generic/UserWalkthroughSteps";

function getWalkthroughSteps(canManageShared: boolean): UserWalkthroughSteps[] {
  const savedStepSix = canManageShared
    ? t("Walkthrough.AnalyticsFilters.Step.Six_ManageShared")
    : t("Walkthrough.AnalyticsFilters.Step.Six");

  const savedStepSeven = canManageShared
    ? t("Walkthrough.AnalyticsFilters.Step.Seven_ManageShared")
    : t("Walkthrough.AnalyticsFilters.Step.Seven");

  return [
    {
      target: "#analytics-filter-band",
      contentTranslationKey: t("Walkthrough.AnalyticsFilters.Step.One"),
    },
    {
      target: "#analytics-filter-journey",
      contentTranslationKey: t("Walkthrough.AnalyticsFilters.Step.Two"),
    },
    {
      target: "#analytics-filter-dates",
      contentTranslationKey: t("Walkthrough.AnalyticsFilters.Step.Three"),
    },
    {
      target: "#analytics-filter-audience",
      contentTranslationKey: t("Walkthrough.AnalyticsFilters.Step.Four"),
    },
    {
      target: "#analytics-filter-band",
      contentTranslationKey: t("Walkthrough.AnalyticsFilters.Step.Five"),
    },
    {
      target: "#analytics-filter-saved",
      contentTranslationKey: savedStepSix,
    },
    {
      target: "#analytics-filter-saved",
      contentTranslationKey: savedStepSeven,
    },
    {
      target: "#analytics-filter-pin-advanced",
      contentTranslationKey: t("Walkthrough.AnalyticsFilters.Step.Eight"),
    },
  ];
}

interface AnalyticsFiltersWalkthroughProps {
  canManageShared: boolean;
  onFinished(): void;
}

function AnalyticsFiltersWalkthrough({
  canManageShared,
  onFinished,
}: AnalyticsFiltersWalkthroughProps) {
  const steps = getWalkthroughSteps(canManageShared);

  return (
    <UserWalkthrough
      walkthroughType="ANALYTICS-FILTERS"
      steps={steps}
      declinedWalkthrough={false}
      onFinished={onFinished}
    />
  );
}

export default AnalyticsFiltersWalkthrough;
